const translations = {
    customers: 'Customers',
    logOut: 'Log Out',
    manageConnections: 'Manage Connections',
    manageEquipment: 'Manage Equipment',
    manageOrganization: 'Manage Organization',
    menuLabel: 'Account menu',
    myAccount: 'My Account',
    myOrganization: 'My Organization',
    serviceProviderMap: 'Service Provider Map'
};

export default translations;
